import { render, staticRenderFns } from "./propertyInit.vue?vue&type=template&id=715db95e&scoped=true"
import script from "./propertyInit.vue?vue&type=script&lang=js"
export * from "./propertyInit.vue?vue&type=script&lang=js"
import style0 from "./propertyInit.vue?vue&type=style&index=0&id=715db95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715db95e",
  null
  
)

export default component.exports